import { memo, useMemo } from 'react';
import Text from '@raydiant/raydial/components/Text';
import { PlanPerPeriod } from './types';
import OrderDetailsItem from './OrderDetailsItem';

interface OrderDetailsProps {
  plan: PlanPerPeriod;
  count: number;
}

const getTotalPrice = (plan: PlanPerPeriod, count: number): string => {
  const { license, device } = plan;
  const currencyFormat = license.currency === 'USD' ? 'US$' : '';

  const licensePrice = license.promotionPrice ?? license.price;
  const devicePrice = device.promotionPrice ?? device.price;

  const total = (licensePrice * count + devicePrice * count).toFixed(2);

  return `${currencyFormat}${total}`;
};

const OrderDetails = ({ plan, count }: OrderDetailsProps) => {
  const { license: licensePlan, device: devicePlan } = plan;

  const totalPrice = useMemo(() => getTotalPrice(plan, count), [plan, count]);

  return (
    <div className="flex flex-col gap-4">
      <Text className="font-bold text-black" variant="body">
        Order Details
      </Text>

      <OrderDetailsItem plan={licensePlan} type="license" count={count} />
      <OrderDetailsItem
        showBadge
        plan={devicePlan}
        type="device"
        count={count}
      />

      <div className="flex justify-between items-end bg-gray-100 px-6 py-4 rounded-xl">
        <div className="flex flex-col gap-2">
          <Text className="text-gray-700">Total</Text>
          <Text className="text-black" variant="smallSubheader">
            With taxes, excluding shipping
          </Text>
        </div>
        <div className="flex flex-col gap-2 items-end">
          <Text className="text-black" variant="smallSubheader">
            {totalPrice}
          </Text>
        </div>
      </div>
    </div>
  );
};

export default memo(OrderDetails);
